import { gql } from 'graphql-request';

export const GET_ENTITIES = gql`
  query allEntityTypes {
    ingressProjections {
      meta {
        id {
          name
          builtIn
        }
        typeId {
          name
          builtIn
        }
      }
    }
    externalProjections {
      meta {
        id {
          name
          builtIn
        }
        typeId {
          name
          builtIn
        }
      }
    }
    allEntityTypes {
      id {
        name
        builtIn
      }
      keyField
      fields {
        name
        builtIn
        displayName
        type
        repeated
        tags
        groupName
        additionalInfo {
          hideFromMapping
        }
      }
    }
    metadataFields {
      name
      builtIn
      displayName
      type
      repeated
      tags: tagsList
    }
    projectionAliasPaths(includeIngressAliases: true, includeRecommendations: true) {
      projId {
        name
        builtIn
      }
      entityTypeId {
        name
        builtIn
      }
      projDisplayName
      aggregates {
        name
        builtIn
      }
      aliases {
        projId {
          name
          builtIn
        }
        entityTypeId {
          name
          builtIn
        }
        alias
        displayName
        usages
        fieldsRecommendation
        fieldsPopulation
      }
    }
  }
`;

export const FIELD_VISIBILITY = gql`
  query findFieldVisibilitiesByAccountId {
    findFieldVisibilitiesByAccountId {
      id
      projectionName
      builtInProjection
      fieldName
      config
    }
  }
`;

export const GET_MEASUREMENT = gql`
  query findMeasurementsByAccountId {
    findMeasurementsByAccountId {
      measurement
      createdByUserId
      updatedByUserId
      id
    }
  }
`;

export const GET_UI_CONFIG = gql`
  query getUIConfigByProjection($projectionName: String) {
    getUIConfigByProjection(projectionName: $projectionName)
  }
`;
